import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const AttachService = {
    getAttach: async (attachId) => axios.get(API_URL + `/attach/${attachId}`, {responseType: 'blob'}).then(({data}) => data).catch(err => { throw err }),
};

export default AttachService;